<div [style.background-image]="('url(' + headerUrl + ')')" class="d-flex flex-row-fluid w-100 header-wrapper"
     style="height: 400px; background-size: cover; background-position: left 27%; border-radius: .4rem">
  <div (click)="pickHeader()" *ngPermissions="permissionService.Permission.company_edit"
       class="userPicEdit userPicEditFar cursor-pointer">
    <sb-icon class="icon-center" icon="edit"></sb-icon>
  </div>
  <div class="d-flex align-items-center text-center flex-column justify-content-center h-100 w-100">
    <sb-card classes="green-border">
      <div card-body>
        <div class="d-flex justify-content-between text-start">
          <div style="position: absolute;top: -67px;display: flex;">
            <div class="image-video-wrapper">
              <ng-container *ngIf="permissionService.hasPermission(permissionService.Permission.company_edit); else noLocationEdit">
                <div (click)="pickLogo()" [style.backgroundImage]="avatarUrl ? 'url('+avatarUrl+')' : ''"
                     class="userPic cursor-pointer">
                  <div class="userPicEdit">
                    <sb-icon class="icon-center" icon="edit"></sb-icon>
                  </div>
                </div>
              </ng-container>
              <ng-template #noLocationEdit>
                <div [style.backgroundImage]="avatarUrl ? 'url('+avatarUrl+')': ''" class="userPic">
                </div>
              </ng-template>
            </div>
            <div class="ml-4">

              <h2 class="font-weight-bolder" style="color: #fdfeff;text-shadow: 0 0 10px #000;">
                <ng-container *ngIf="company?.identifier || company?.name">
                  <ng-container *ngIf="company?.identifier && company?.name">
                    {{ company?.name }}&nbsp;({{ company?.identifier }})
                  </ng-container>
                  <ng-container *ngIf="company?.identifier && !company?.name">
                    {{ company?.identifier }}
                  </ng-container>
                  <ng-container *ngIf="!company?.identifier && company?.name">
                    {{ company?.name }}
                  </ng-container>
                </ng-container>
              </h2>
              <div class="d-flex align-items-center">

                <h6 style="color: #fdfeff;text-shadow: 0 0 5px #000;">
                  {{'lang.globals.companyId:' | translate}}
                  {{company?.id}}
                </h6>
                <div class="ml-2" *ngPermissions="permissionService.Permission.tag_list">
                  <sb-tags [dtoId]="company?.id" [dtoType]="tagService.TaggableDTO.Company"
                           [tags]="company?.tags"></sb-tags>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-row" style="padding-left: 10rem">
            <ng-container *ngFor="let costatus of status; last as last;">
              <div [ngClass]="!last || last ? 'border-dashed-right' : ''"
                   class="d-flex align-items-center px-1">
                <button [ngClass]="costatus?.value ? 'green-bg' : 'grey-bg'" container="body"
                        class="btn white" ngbTooltip="{{'lang.companyDetails.' + costatus.type | translate}}"
                        placement="top" style="box-shadow: 0 2px 4px 0 rgba(90,141,238,.5)">
                  <sb-icon *ngIf="costatus?.value" icon="success">
                  </sb-icon>
                  <sb-icon *ngIf="!costatus?.value" icon="error">
                  </sb-icon>
                  {{'lang.companyDetails.' + costatus.type | translate}}
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>

<!-- <div class="d-flex flex-row-fluid w-100" [style.background-image]="'url(./assets/img/' + 'companydetails-bg.jpg)'"
    style="height: 400px; background-size: cover; background-position: left 27%; border-radius: .4rem">
    <div class="d-flex align-items-center text-center flex-column justify-content-center h-100 w-100"
        style="position: relative;">

        <sb-card>
            <div card-body>
                <div class="d-flex justify-content-center text-center">
                    <div style="position: absolute;top: -67px;display: flex;">
                        <div>
                            <h2 style="color: #fdfeff;text-shadow: 0 0 10px #000;" class="font-weight-bolder">
                                <ng-container *ngIf="company?.identifier || company?.name">
                                    <ng-container *ngIf="company?.identifier && company?.name">
                                        {{ company?.name }}&nbsp;({{ company?.identifier }})
                                    </ng-container>
                                    <ng-container *ngIf="company?.identifier && !company?.name">
                                        {{ company?.identifier }}
                                    </ng-container>
                                    <ng-container *ngIf="!company?.identifier && company?.name">
                                        {{ company?.name }}
                                    </ng-container>
                                </ng-container>
                            </h2>
                            <h3 style="color: #fdfeff;text-shadow: 0 0 10px #000;" class="font-weight-bolder">
                                {{ 'lang.globals.company' | translate }}&nbsp;{{ company?.id }}
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between text-start">
                    <div class="d-flex flex-row">
                        <ng-container *ngFor="let costatus of status; last as last;">
                            <div class="d-flex align-items-center px-1"
                                [ngClass]="!last || last ? 'border-dashed-right' : ''">
                                <button container="body" ngbTooltip="{{'lang.companyDetails.' + costatus.type | translate}}"
                                    placement="top" style="box-shadow: 0 2px 4px 0 rgba(90,141,238,.5)"
                                    class="btn white" [ngClass]="costatus?.value ? 'green-bg' : 'grey-bg'">
                                    <fa-icon *ngIf="costatus?.value" [icon]="'check-circle'">
                                    </fa-icon>
                                    <fa-icon *ngIf="!costatus?.value" [icon]="'times-circle'">
                                    </fa-icon>
                                    {{'lang.companyDetails.' + costatus.type | translate}}
                                </button>
                            </div>
                        </ng-container>
                        <div class="d-flex align-items-center pr-1 pl-1">
                            <a *ngPermissions="permissionService.Permission.company_edit" container="body"
                                ngbTooltip="{{ 'lang.globals.editCompany' | translate }}" placement="top"
                                [queryParams]="{returnTo: this.util.getPageLink()}"
                                [routerLink]="['/datasets/companies/company-edit/' + company?.id]">
                                <button class="btn btn-hover-primary">
                                    <sb-icon icon="edit"></sb-icon>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </sb-card>
    </div>
</div> -->


<div class="px-0 px-sm-0 px-md-2 px-lg-4 px-xl-5 px-xxl-10 px-xxxl-10" style="margin-top: -100px">
  <div class="row">
    <div class="col-lg-12 col-xl-3">
      <sb-card>
        <div card-body>
          <ul class="nav-tabs nav sidenav">
            <li class="nav-item">
              <a [isLinkActive]="util.RoutingID.companyDetailsOverview" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.companyDetailsOverview"
                 class="nav-link"><span>
                                    <sb-icon class="mr-3" icon="eye"></sb-icon>
                {{'nav.network.companies.details.overview' | translate}}
                                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.company_attributes_show" class="nav-item">
              <a [isLinkActive]="util.RoutingID.companyDetailsAttributes" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.companyDetailsAttributes"
                 class="nav-link"><span>
                                    <sb-icon class="mr-3" icon="attributes"></sb-icon>
                {{'nav.network.companies.details.attributes' | translate}}
                                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.location_list" class="nav-item">
              <a [isLinkActive]="util.RoutingID.companyDetailsLocations" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.companyDetailsLocations"
                 class="nav-link"><span>
                                    <sb-icon class="mr-3" icon="locationStreet"></sb-icon>
                {{'nav.network.companies.details.locations' | translate}}
                                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.campaign_list" class="nav-item">
              <a [isLinkActive]="util.RoutingID.companyDetailsCampaigns" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.companyDetailsCampaigns"
                 class="nav-link"><span>
                                    <sb-icon class="mr-3" icon="megaphone"></sb-icon>
                {{'nav.network.companies.details.campaigns' | translate}}
                                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.medium_list" class="nav-item">
              <a [isLinkActive]="util.RoutingID.companyDetailsMedia" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.companyDetailsMedia"
                 class="nav-link"><span>
                                    <sb-icon class="mr-3" icon="motive"></sb-icon>
                {{'nav.network.companies.details.media' | translate}}
                                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.medium_group_list" class="nav-item">
              <a [isLinkActive]="util.RoutingID.companyDetailsMediumgroups" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.companyDetailsMediumgroups"
                 class="nav-link"><span>
                                    <sb-icon class="mr-3" icon="motives"></sb-icon>
                {{'nav.network.companies.details.mediumgroups' | translate}}
                                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.area_list" class="nav-item">
              <a [isLinkActive]="util.RoutingID.companyDetailsAreas" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.companyDetailsAreas"
                 class="nav-link"><span>
                                    <sb-icon class="mr-3" icon="globe"></sb-icon>
                {{'nav.network.companies.details.areas' | translate}}
                                </span></a>
            </li>
            <li *ngPermissions="permissionService.Permission.cull_list" class="nav-item">
              <a [isLinkActive]="util.RoutingID.companyDetailsCulls" [sbRouterLinkActive]="'active'"
                 [sbRouterLink]="util.RoutingID.companyDetailsCulls"
                 class="nav-link"><span>
                                    <sb-icon class="mr-3" icon="filter"></sb-icon>
                {{'nav.network.companies.details.culls' | translate}}
                                </span></a>
            </li>
          </ul>
        </div>
      </sb-card>
    </div>
    <div class="col-lg-12 col-xl-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<ng-container *sbPageAction>
  <a *ngPermissions="permissionService.Permission.company_edit"
     [pathParams]="[{id: 'companyID', value: company?.id}]"
     [queryParams]="{returnTo: this.util.getPageLink()}" [sbRouterLink]="util.RoutingID.companyEdit">
    <button class="btn btn-primary">
      <sb-icon class="mr-2" icon="edit"></sb-icon>
      {{ 'lang.globals.editCompany' | translate }}
    </button>
  </a>
</ng-container>
